"use strict";

exports.__esModule = true;
exports.fbq = void 0;

/**
 * Facebook pixel `fbq` function
 */
var fbq = typeof window !== 'undefined' && typeof window.fbq === 'function' ? window.fbq : function () {};
exports.fbq = fbq;